import { render, staticRenderFns } from "./profitsGraphs.vue?vue&type=template&id=d0ff32dc"
import script from "./profitsGraphs.vue?vue&type=script&lang=js"
export * from "./profitsGraphs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports